import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Dialog,
  FormGroup,
  makeStyles,
  withStyles,
  Typography,
} from "@material-ui/core";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { useTranslation } from "react-i18next";
import { deleteEntityAssociations } from "../../../../../../API/Entity";
import CheckBox from "../../../../../../Component/Forms/CheckboxWithLabel";
import ModalDialogContext from "../../../../../../Context/ModalDialog/ModalDialogContext";
import styles from "./styles";
import CustomButton from "../../../../../../Component/CustomButton";

const useStyles = makeStyles(styles);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const RemoveAssociationDialog = (props) => {
  const { isDialogOpen, record, childRecords = [], onClose, onSubmit } = props;
  const classes = useStyles();

  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedChilds, setSelectedChilds] = useState({});
  const [errorMessage, setErrorMessage] = useState();

  const { t } = useTranslation();

  const { showMessage, showConfirmation, showErrorMessage } =
    useContext(ModalDialogContext);

  useEffect(() => {
    if (record) {
    }
  }, [record]);

  const handleChange = (e, id) => {
    setSelectedChilds({ ...selectedChilds, [id]: e.target.checked });
  };

  const handleClose = (status) => {
    if (onClose) {
      onClose(status);
    }
  };

  const cancel = () => {
    handleClose("cancel");
  };

  const handleSubmit = async () => {
    const associations = [];
    let childRecordNames = "";
    for (let c in selectedChilds) {
      if (selectedChilds[c]) {
        associations.push({
          entityId: c,
          targetEntityId: record.id,
          associationId: "2",
        });
        childRecordNames = `${childRecordNames}${
          childRecordNames.length > 0 ? "," : ""
        }${childRecords.find((cr) => cr.id === c).recordName}`;
      }
    }
    if (associations.length === 0) {
      setErrorMessage(t("messages.record.associations.associationError"));
      return;
    }
    showConfirmation({
      message: t("messages.record.associations.deleteBeneficialOwner", {
        recordName: record.recordName,
        childRecordNames,
      }),
      onPressYes: async (event) => {
        setIsUpdating(true);
        try {
          const result = await deleteEntityAssociations(associations);
          const { message } = result || {};
          showMessage({ message });
        } catch (error) {
          showErrorMessage({ error });
        }
        setIsUpdating(false);
        handleClose();
      },
    });
  };

  const renderCreateForm = () => {
    return (
      <Grid container spacing={3}>
        <Grid item container xs={12} justify="center">
          <Typography component="span" className={classes.recordName}>
            {t("messages.record.associations.selectChildOfBo", {
              recordName: record.recordName,
            })}
          </Typography>
        </Grid>
        <Grid item container xs={12} alignContent="center">
          <FormGroup>
            {childRecords
              .filter((cr) => cr.permissions.canRemoveAssociation)
              .map((r, index) => {
                return (
                  <div className={classes.checkBoxContainer} key={index}>
                    <CheckBox
                      label={r.recordName}
                      onChange={(e) => handleChange(e, r.id)}
                      value={selectedChilds[r.id] || false}
                    />
                  </div>
                );
              })}
          </FormGroup>
        </Grid>
        <Grid item container xs={12}>
          <span className={classes.errorText}>{errorMessage}</span>
        </Grid>
      </Grid>
    );
  };

  return (
    <Dialog
      disableBackdropClick
      onClose={cancel}
      aria-labelledby="update-ownership-percentage"
      open={isDialogOpen}
      maxWidth="xs"
    >
      <DialogContent dividers>{renderCreateForm()}</DialogContent>
      <DialogActions>
        <CustomButton 
          variant="secondary" 
          onClick={cancel}
        >
          {t("labels.common.cancel")}
        </CustomButton>
        <CustomButton 
          variant="primary" 
          loadingText={t("labels.common.submiting")}
          isLoading={isUpdating}
          onClick={handleSubmit}
        >
          {t("labels.common.submit")}
        </CustomButton>
        
      </DialogActions>
    </Dialog>
  );
};

export default RemoveAssociationDialog;
